/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useState, useEffect } from 'react';

// Sagas
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import 'react-image-lightbox/style.css';
import { withTranslation } from 'react-i18next';

import {
  Card, CardBody, Collapse, Button, Dropdown, DropdownToggle, DropdownMenu, DropdownItem,
} from 'reactstrap';

import OrderCountChart from './OrderCountChart';
import OrderCountTimeChart from './OrderCountTimeChart';
import GrossRevenueWidget from './GrossRevenueWidget';
import SourcingProductivityChart from './SourcingProductivityChart';
import ReturnsProductivityChart from './ReturnsProductivityChart';
import TVProductivityChart from './TVProductivityChart';
import TeardownProductivityChart from './TeardownProductivityChart';
import BigCommercePaymentMethodChart from './BigCommercePaymentMethodChart';
import OrderTrendWidget from './OrderTrendWidget';
import CategorySalesWidget from './CategorySalesWidget';

const DASHBOARD_LAYOUT_KEY = 'dashboardTileOrder_v1';
const DASHBOARD_LAYOUT_PRESETS = [
  {
    id: '4x4x4',
    label: '4x4x4',
    className: 'is-preset-4-4-4',
    columnCount: 3,
  },
  {
    id: '3x4x5',
    label: '3x4x5',
    className: 'is-preset-3-4-5',
    columnCount: 3,
  },
  {
    id: '3x3x6',
    label: '3x3x6',
    className: 'is-preset-3-3-6',
    columnCount: 3,
  },
  {
    id: '5x7',
    label: '5x7',
    className: 'is-preset-5-7',
    columnCount: 2,
  },
  {
    id: '8x4',
    label: '8x4',
    className: 'is-preset-8-4',
    columnCount: 2,
  },
  {
    id: '4x8',
    label: '4x8',
    className: 'is-preset-4-8',
    columnCount: 2,
  },
];
const DEFAULT_LAYOUT_PRESET_ID = '3x3x6';
const DASHBOARD_TILE_DEFINITIONS = [
  {
    id: 'gross-daily',
    defaultColumn: 0,
    titleKey: 'Daily Gross Revenue',
    render: ({ localDate, t, toggleDatePicker }) => (
      <GrossRevenueWidget
        date={localDate}
        toggleDatePicker={toggleDatePicker}
      />
    ),
  },
  {
    id: 'gross-monthly',
    defaultColumn: 0,
    titleKey: 'Monthly Gross Revenue',
    render: ({ localDate, t, toggleDatePicker }) => (
      <GrossRevenueWidget
        date={localDate}
        mode="monthly"
        overrideTitle={t('Monthly Gross Revenue')}
        toggleDatePicker={toggleDatePicker}
      />
    ),
  },
  {
    id: 'order-count',
    defaultColumn: 0,
    titleKey: 'Order Count',
    render: ({ localDate, t }) => (
      <Card className="dashboard-panel">
        <CardBody className="dashboard-panel__body">
          <div className="dashboard-panel__header">
            <div>
              <span className="dashboard-panel__eyebrow">{t('Orders')}</span>
              <h5 className="dashboard-panel__title">{t('Order Count')}</h5>
            </div>
            <span className="dashboard-panel__hint">{t('Today vs last week')}</span>
          </div>
          <OrderCountChart date={localDate} />
        </CardBody>
      </Card>
    ),
  },
  {
    id: 'order-count-by-time',
    defaultColumn: 2,
    titleKey: 'Order Count by Time',
    render: ({ localDate, t }) => (
      <Card className="dashboard-panel">
        <CardBody className="dashboard-panel__body">
          <div className="dashboard-panel__header">
            <div>
              <span className="dashboard-panel__eyebrow">{t('Orders')}</span>
              <h5 className="dashboard-panel__title">{t('Order Count by Time')}</h5>
            </div>
            <span className="dashboard-panel__hint">{t('Selected day vs average')}</span>
          </div>
          <OrderCountTimeChart date={localDate} />
        </CardBody>
      </Card>
    ),
  },
  {
    id: 'sourcing-productivity',
    defaultColumn: 1,
    titleKey: 'Sourcing Productivity',
    render: ({ localDate, t }) => (
      <Card className="dashboard-panel">
        <CardBody className="dashboard-panel__body">
          <div className="dashboard-panel__header">
            <div>
              <span className="dashboard-panel__eyebrow">{t('Warehouse')}</span>
              <h5 className="dashboard-panel__title">{t('Sourcing Productivity')}</h5>
            </div>
            <span className="dashboard-panel__hint">{t('Parts inducted')}</span>
          </div>
          <SourcingProductivityChart date={localDate} />
        </CardBody>
      </Card>
    ),
  },
  {
    id: 'returns-productivity',
    defaultColumn: 1,
    titleKey: 'Returns Productivity',
    render: ({ localDate, t }) => (
      <Card className="dashboard-panel">
        <CardBody className="dashboard-panel__body">
          <div className="dashboard-panel__header">
            <div>
              <span className="dashboard-panel__eyebrow">{t('Operations')}</span>
              <h5 className="dashboard-panel__title">{t('Returns Productivity')}</h5>
            </div>
            <span className="dashboard-panel__hint">{t('Returns and restocks')}</span>
          </div>
          <ReturnsProductivityChart date={localDate} />
        </CardBody>
      </Card>
    ),
  },
  {
    id: 'bc-payment-methods',
    defaultColumn: 1,
    titleKey: 'BigCommerce Payment Methods',
    render: ({ localDate, t }) => (
      <Card className="dashboard-panel">
        <CardBody className="dashboard-panel__body">
          <div className="dashboard-panel__header">
            <div>
              <span className="dashboard-panel__eyebrow">{t('BigCommerce')}</span>
              <h5 className="dashboard-panel__title">{t('Payment Methods')}</h5>
            </div>
            <span className="dashboard-panel__hint">{t('Daily order mix')}</span>
          </div>
          <BigCommercePaymentMethodChart date={localDate} />
        </CardBody>
      </Card>
    ),
  },
  {
    id: 'tv-productivity',
    defaultColumn: 2,
    titleKey: 'TV Productivity',
    render: ({ localDate, t }) => (
      <Card className="dashboard-panel">
        <CardBody className="dashboard-panel__body">
          <div className="dashboard-panel__header">
            <div>
              <span className="dashboard-panel__eyebrow">{t('TVs')}</span>
              <h5 className="dashboard-panel__title">{t('TV Productivity')}</h5>
            </div>
            <span className="dashboard-panel__hint">{t('Inducted TVs')}</span>
          </div>
          <TVProductivityChart date={localDate} />
        </CardBody>
      </Card>
    ),
  },
  {
    id: 'teardown-productivity',
    defaultColumn: 2,
    titleKey: 'Teardown Productivity',
    render: ({ localDate, t }) => (
      <Card className="dashboard-panel">
        <CardBody className="dashboard-panel__body">
          <div className="dashboard-panel__header">
            <div>
              <span className="dashboard-panel__eyebrow">{t('TVs')}</span>
              <h5 className="dashboard-panel__title">{t('Teardown Productivity')}</h5>
            </div>
            <span className="dashboard-panel__hint">{t('Completed TVs and kits')}</span>
          </div>

          <TeardownProductivityChart date={localDate} />
        </CardBody>
      </Card>
    ),
  },
  {
    id: 'category-sales-changes',
    defaultColumn: 2,
    titleKey: 'Category Sales Changes',
    render: () => (
      <CategorySalesWidget />
    ),
  },
];
const DASHBOARD_TILE_IDS = DASHBOARD_TILE_DEFINITIONS.map((tile) => tile.id);
const DASHBOARD_TILE_BY_ID = DASHBOARD_TILE_DEFINITIONS.reduce((acc, tile) => ({
  ...acc,
  [tile.id]: tile,
}), {});
const getLayoutPreset = (presetId) => (
  DASHBOARD_LAYOUT_PRESETS.find((preset) => preset.id === presetId) || DASHBOARD_LAYOUT_PRESETS[0]
);
const createEmptyColumns = (columnCount) => Array.from({ length: columnCount }, () => []);
const DEFAULT_TILE_COLUMNS = [0, 1, 2].map((columnIndex) => (
  DASHBOARD_TILE_DEFINITIONS
    .filter((tile) => tile.defaultColumn === columnIndex)
    .map((tile) => tile.id)
));

const alignColumnsToPreset = (rawColumns, preset) => {
  const alignedColumns = createEmptyColumns(preset.columnCount);

  rawColumns.forEach((column, columnIndex) => {
    const targetColumnIndex = Math.min(columnIndex, preset.columnCount - 1);
    alignedColumns[targetColumnIndex].push(...column);
  });

  return alignedColumns;
};

const normalizeTileLayout = (layout) => {
  const preset = getLayoutPreset(layout?.preset);
  let rawColumns = DEFAULT_TILE_COLUMNS;
  if (Array.isArray(layout?.columns)) {
    rawColumns = layout.columns;
  } else if (Array.isArray(layout)) {
    rawColumns = layout;
  }
  const rawHidden = Array.isArray(layout?.hidden) ? layout.hidden : [];
  const presetColumns = alignColumnsToPreset(rawColumns, preset);
  const normalizedColumns = presetColumns.map((column) => (
    Array.isArray(column) ? [...column] : []
  ));

  const seen = new Set();
  const columns = normalizedColumns.map((column) => column.filter((tileId) => {
    if (!DASHBOARD_TILE_IDS.includes(tileId) || seen.has(tileId)) {
      return false;
    }

    seen.add(tileId);
    return true;
  }));

  const hidden = rawHidden.filter((tileId) => {
    if (!DASHBOARD_TILE_IDS.includes(tileId) || seen.has(tileId)) {
      return false;
    }

    seen.add(tileId);
    return true;
  });

  const missing = DASHBOARD_TILE_IDS.filter((tileId) => !seen.has(tileId));
  missing.forEach((tileId) => {
    const { defaultColumn } = DASHBOARD_TILE_BY_ID[tileId];
    columns[Math.min(defaultColumn, preset.columnCount - 1)].push(tileId);
  });

  return {
    preset: preset.id,
    columns,
    hidden,
  };
};

const moveTileBetweenColumns = (columns, draggedTile, targetColumnIndex, targetIndex) => {
  const nextColumns = columns.map((column) => [...column]);
  const sourceColumnIndex = nextColumns.findIndex((column) => column.includes(draggedTile.id));

  if (sourceColumnIndex === -1) {
    return columns;
  }

  const sourceTileIndex = nextColumns[sourceColumnIndex].indexOf(draggedTile.id);
  nextColumns[sourceColumnIndex].splice(sourceTileIndex, 1);

  const safeTargetIndex = Math.max(0, Math.min(targetIndex, nextColumns[targetColumnIndex].length));
  nextColumns[targetColumnIndex].splice(safeTargetIndex, 0, draggedTile.id);

  return nextColumns;
};

const getInitialTileColumns = () => {
  try {
    const rawTileLayout = localStorage.getItem(DASHBOARD_LAYOUT_KEY);
    if (rawTileLayout === null) {
      return normalizeTileLayout(DEFAULT_TILE_COLUMNS);
    }

    const parsedTileLayout = JSON.parse(rawTileLayout);

    if (Array.isArray(parsedTileLayout) && parsedTileLayout.every((entry) => typeof entry === 'string')) {
      const migratedColumns = [[], [], []];
      parsedTileLayout.forEach((tileId, index) => {
        if (DASHBOARD_TILE_IDS.includes(tileId)) {
          migratedColumns[index % migratedColumns.length].push(tileId);
        }
      });

      return normalizeTileLayout({
        preset: DEFAULT_LAYOUT_PRESET_ID,
        columns: migratedColumns,
      });
    }

    return normalizeTileLayout(parsedTileLayout);
  } catch (error) {
    localStorage.removeItem(DASHBOARD_LAYOUT_KEY);
    return normalizeTileLayout(DEFAULT_TILE_COLUMNS);
  }
};

function Dashboard(props) {
  const { t } = props;

  const [date, setDate] = useState(new Date());
  const [datepicker, setDatepicker] = useState(false);
  const [localDate, setLocalDate] = useState(null);
  const [tileLayout, setTileLayout] = useState(getInitialTileColumns);
  const [draggedTile, setDraggedTile] = useState(null);
  const [settingsOpen, setSettingsOpen] = useState(false);
  const isDraggingTile = draggedTile !== null;

  const layoutPreset = getLayoutPreset(tileLayout.preset);
  const tileColumns = tileLayout.columns;
  const hiddenTileIds = tileLayout.hidden;

  useEffect(() => {
    localStorage.setItem(DASHBOARD_LAYOUT_KEY, JSON.stringify(tileLayout));
  }, [tileLayout]);

  useEffect(() => {
    const userSelectedDate = new Date(date); // Clone the date instead of mutating it

    userSelectedDate.setHours(0, 0, 0, 0); // Safe to modify the copy now
    const lDate = userSelectedDate.toISOString().split('T')[0];
    const offsetMinutes = userSelectedDate.getTimezoneOffset();
    const sign = offsetMinutes > 0 ? '-' : '+';
    const absOffsetMinutes = Math.abs(offsetMinutes);
    const offsetHours = String(Math.floor(absOffsetMinutes / 60)).padStart(2, '0');
    const offsetMins = String(absOffsetMinutes % 60).padStart(2, '0');
    const timezoneOffset = `${sign}${offsetHours}:${offsetMins}`;
    const localISODate = `${lDate}T00:00:00.000${timezoneOffset}`;

    setLocalDate(localISODate);
  }, [date]);

  const formatInputDate = (value) => value.toISOString().split('T')[0];

  const formatLongDate = (value) => (
    value.toLocaleDateString('en-US', {
      weekday: 'long',
      month: 'long',
      day: 'numeric',
      year: 'numeric',
    })
  );

  const formatMonthFocus = (value) => (
    value.toLocaleDateString('en-US', {
      month: 'long',
      year: 'numeric',
    })
  );

  const handleTileDrop = (targetColumnIndex, targetIndex) => {
    if (draggedTile === null) {
      return;
    }

    setTileLayout((currentLayout) => ({
      ...currentLayout,
      columns: moveTileBetweenColumns(
        currentLayout.columns,
        draggedTile,
        targetColumnIndex,
        targetIndex,
      ),
    }));
    setDraggedTile(null);
  };

  const resetTileOrder = () => {
    setTileLayout(normalizeTileLayout({
      preset: tileLayout.preset,
      columns: DEFAULT_TILE_COLUMNS,
      hidden: [],
    }));
  };

  const changeLayoutPreset = (presetId) => {
    setTileLayout((currentLayout) => normalizeTileLayout({
      ...currentLayout,
      preset: presetId,
    }));
  };

  const hideTile = (tileId) => {
    setTileLayout((currentLayout) => {
      const nextColumns = currentLayout.columns.map((column) => (
        column.filter((currentTileId) => currentTileId !== tileId)
      ));
      const nextHidden = currentLayout.hidden.includes(tileId)
        ? currentLayout.hidden
        : [...currentLayout.hidden, tileId];

      return {
        preset: currentLayout.preset,
        columns: nextColumns,
        hidden: nextHidden,
      };
    });
  };

  const showTile = (tileId) => {
    const tile = DASHBOARD_TILE_BY_ID[tileId];
    if (tile === undefined) {
      return;
    }

    setTileLayout((currentLayout) => ({
      columns: currentLayout.columns.map((column, index) => (
        index === Math.min(tile.defaultColumn, currentLayout.columns.length - 1)
          ? [...column, tileId] : column
      )),
      preset: currentLayout.preset,
      hidden: currentLayout.hidden.filter((currentTileId) => currentTileId !== tileId),
    }));
  };

  const jsx = (
    <div className="page-content dashboard-page">
      <div className="container-fluid">
        <div className="dashboard-toolbar mb-4">
          <div className="dashboard-toolbar__meta">
            <div className="dashboard-pill">
              <span className="dashboard-pill__label">{t('Selected day')}</span>
              <span className="dashboard-pill__value">{formatLongDate(date)}</span>
            </div>
            <div className="dashboard-pill">
              <span className="dashboard-pill__label">{t('Month focus')}</span>
              <span className="dashboard-pill__value">{formatMonthFocus(date)}</span>
            </div>
            <div className="dashboard-pill">
              <span className="dashboard-pill__label">{t('View controls')}</span>
              <div className="dashboard-pill__actions">
                <Button
                  color="light"
                  className="w-100 rounded-pill fw-semibold"
                  onClick={() => setDatepicker(!datepicker)}
                >
                  <span className="mdi mdi-calendar-month me-2" />
                  {datepicker ? t('Hide date picker') : t('Choose a date')}
                </Button>
                <Button
                  color="light"
                  className="w-100 rounded-pill fw-semibold"
                  onClick={resetTileOrder}
                >
                  <span className="mdi mdi-refresh me-2" />
                  {t('Reset tiles')}
                </Button>
              </div>
            </div>
            <Dropdown isOpen={settingsOpen} toggle={() => setSettingsOpen(!settingsOpen)}>
              <DropdownToggle color="light" className="dashboard-settings-button rounded-pill">
                <span className="mdi mdi-cog-outline" />
              </DropdownToggle>
              <DropdownMenu end className="dashboard-settings-menu">
                <DropdownItem header>{t('Column layout')}</DropdownItem>
                {DASHBOARD_LAYOUT_PRESETS.map((preset) => (
                  <DropdownItem
                    key={preset.id}
                    active={tileLayout.preset === preset.id}
                    onClick={() => changeLayoutPreset(preset.id)}
                  >
                    <span className={`mdi ${tileLayout.preset === preset.id ? 'mdi-radiobox-marked' : 'mdi-radiobox-blank'} me-2`} />
                    {preset.label}
                  </DropdownItem>
                ))}
                <DropdownItem divider />
                <DropdownItem header>{t('Hidden widgets')}</DropdownItem>
                {hiddenTileIds.length === 0 && (
                  <DropdownItem disabled>{t('No hidden widgets')}</DropdownItem>
                )}
                {hiddenTileIds.map((tileId) => {
                  const tile = DASHBOARD_TILE_BY_ID[tileId];
                  if (tile === undefined) {
                    return null;
                  }

                  return (
                    <DropdownItem key={tileId} onClick={() => showTile(tileId)}>
                      <span className="mdi mdi-plus me-2" />
                      {t(tile.titleKey)}
                    </DropdownItem>
                  );
                })}
              </DropdownMenu>
            </Dropdown>
          </div>
        </div>

        <Collapse isOpen={datepicker}>
          <Card className="dashboard-date-panel mb-4">
            <CardBody className="dashboard-panel__body">
              <span className="dashboard-panel__eyebrow">{t('Date')}</span>
              <h5 className="dashboard-panel__title mb-3">{t('Choose the day for the dashboard')}</h5>
              <input
                className="form-control"
                type="date"
                value={formatInputDate(date)}
                onChange={(e) => {
                  const [year, month, day] = e.target.value.split('-').map(Number);
                  const lDate = new Date(year, month - 1, day);
                  setDate(lDate);
                }}
              />
            </CardBody>
          </Card>
        </Collapse>

        {localDate !== null && (
          <div className={`dashboard-columns ${layoutPreset.className}`}>
            {tileColumns.map((column, columnIndex) => (
              <div
                key={`column_${columnIndex.toString()}`}
                className={`dashboard-column-dropzone ${isDraggingTile ? 'is-drag-active' : ''}`}
                onDragOver={(event) => {
                  event.preventDefault();
                  const { dataTransfer } = event;
                  dataTransfer.dropEffect = 'move';
                }}
                onDrop={(event) => {
                  event.preventDefault();
                  handleTileDrop(columnIndex, column.length);
                }}
              >
                {column.length === 0 && (
                  <div
                    className="dashboard-empty-column"
                    onDragOver={(event) => {
                      event.preventDefault();
                      const { dataTransfer } = event;
                      dataTransfer.dropEffect = 'move';
                    }}
                    onDrop={(event) => {
                      event.preventDefault();
                      handleTileDrop(columnIndex, 0);
                    }}
                  >
                    <span className="mdi mdi-plus-box-outline me-2" />
                    {t('Drop widget here')}
                  </div>
                )}
                {column.map((tileId, tileIndex) => {
                  const tile = DASHBOARD_TILE_BY_ID[tileId];
                  if (tile === undefined) {
                    return null;
                  }

                  return (
                    <div key={tile.id}>
                      <div
                        className="dashboard-drop-slot"
                        onDragOver={(event) => {
                          event.preventDefault();
                          const { dataTransfer } = event;
                          dataTransfer.dropEffect = 'move';
                        }}
                        onDrop={(event) => {
                          event.preventDefault();
                          handleTileDrop(columnIndex, tileIndex);
                        }}
                      />
                      <div
                        className={`dashboard-tile ${draggedTile?.id === tile.id ? 'is-dragging' : ''}`}
                      >
                        <div className="dashboard-tile__actions">
                          <button
                            type="button"
                            className="dashboard-tile__action"
                            title={t('Hide widget')}
                            aria-label={t(`Hide ${t(tile.titleKey)}`)}
                            onClick={() => hideTile(tile.id)}
                          >
                            <span className="mdi mdi-eye-off-outline" />
                          </button>
                          <button
                            type="button"
                            className="dashboard-tile__action dashboard-tile__handle"
                            title={t('Drag to reorder')}
                            aria-label={t(`Drag to reorder ${t(tile.titleKey)}`)}
                            draggable
                            onDragStart={(event) => {
                              setDraggedTile({
                                id: tile.id,
                                columnIndex,
                                tileIndex,
                              });
                              const { dataTransfer } = event;
                              dataTransfer.effectAllowed = 'move';
                            }}
                            onDragEnd={() => {
                              setDraggedTile(null);
                            }}
                          >
                            <span className="mdi mdi-drag" />
                          </button>
                        </div>
                        {tile.render({
                          localDate,
                          t,
                          toggleDatePicker: () => { setDatepicker(!datepicker); },
                        })}
                      </div>
                    </div>
                  );
                })}
                <div
                  className="dashboard-drop-slot dashboard-drop-slot--tail"
                  onDragOver={(event) => {
                    event.preventDefault();
                    const { dataTransfer } = event;
                    dataTransfer.dropEffect = 'move';
                  }}
                  onDrop={(event) => {
                    event.preventDefault();
                    handleTileDrop(columnIndex, column.length);
                  }}
                />
              </div>
            ))}
          </div>
        )}
        {localDate !== null && <OrderTrendWidget date={localDate} />}
      </div>
    </div>
  );

  return jsx;
}

Dashboard.propTypes = {
  // eslint-disable-next-line react/require-default-props
  t: PropTypes.any,
};

export default connect(() => ({

}), {})(withTranslation()(Dashboard));
